// extracted by mini-css-extract-plugin
export var checkbox = "_2o-0";
export var circle = "_2o-3";
export var horizontalContainer = "_2o-7";
export var sm = "_2o-5";
export var switch0 = "_2o-2";
export var switchDisabled = "_2o-8";
export var switchEnabled = "_2o-1";
export var textSwitchContainer = "_2o-9";
export var textSwitchOption = "_2o-a";
export var textSwitchOptionSelected = "_2o-b";
export var verticalContainer = "_2o-6";
export var xs = "_2o-4";